import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Route
} from "react-router-dom";

import './App.css';

import Enroll from './enrollment/Enroll';
import EnrollCompleted from './enrollment/Enroll-completed';
import Admin from './admin/Admin';
import Job from './job/Job';
import JobApplicationCompleted from './job/JobApplicationCompleted';

class App extends Component {
    render() {
        return (
            <Router>
                <div>
                    <Route exact path="/" component={Enroll}/>
                    <Route path="/enroll" component={Enroll}/>
                    <Route path="/enrollCompleted" component={EnrollCompleted}/>
                    <Route path="/admin" component={Admin} />
                    <Route path="/job" component={Job} />
                    <Route path="/jobApplicationCompleted" component={JobApplicationCompleted} />
                </div>
            </Router>
        );
    }
}

export default App;
